module.exports = __webpack_public_path__ + "static/media/SpeechRecognition.6a04b3cd.png";